export const DEVICE_TYPE = {
  MINIPROGRAM: 'miniProgram' // 小程序环境
}

export const isMiniProgram = function () {
  return /miniProgram/.test(navigator.userAgent)
}



// WEBPACK FOOTER //
// ./src/tools/device.js